export const onOpenCampaignBasedOnJob = (job) => {
  window.open(job.campaignLink, "_blank");
};
